var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramHealth48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Health48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Health-Heart",
    transform: "translate(3.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1395459,13.0159791 L36.2041664,12.9118302 C37.2223545,11.5360795 37.77052,9.90898909 37.77052,8.25 C37.77052,4.05426459 34.2114881,0.75 29.64992,0.75 C26.6810599,0.75 23.9740909,2.29415246 22.5498757,4.76784273 L21.24996,7.02543522 L19.9500401,4.76783544 C18.5257208,2.2941243 15.8188266,0.75 12.85,0.75 C8.3683391,0.75 4.75,4.22943954 4.75,8.5019 C4.75,10.7618798 5.76675932,12.8837828 7.61617692,14.426782 L21.23915,29.0506262 L36.040237,13.2097864 L36.1395459,13.0159791 Z",
    id: "HeartBackground",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.65987,13.645172 L36.80702,13.358 C37.91302,11.8636 38.52052,10.0823 38.52052,8.25 C38.52052,3.6199 34.60602,0 29.64992,0 C26.39052,0 23.44712,1.7063 21.89992,4.3936 L21.24996,5.5224 L20.6,4.3936 C19.0527,1.7063 16.1094,0 12.85,0 C7.9562,0 4,3.8127 4,8.5019 C4,11.0045 5.1315,13.3312 7.0674,14.938 L21.238326,30.150055 L36.65987,13.645172 Z",
    id: "Heart",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    points: "0.75 14 15 14 19 9 22 20 25 14 38 14"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-14",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFCC00",
    cx: 37.5,
    cy: 13.5,
    r: 3.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramHealth48);
export default __webpack_public_path__ + "static/media/pictogramHealth48.a6348fcb114e22d6a25db39ee0fd78ee.svg";
export { ForwardRef as ReactComponent };